import qs from 'qs'

import { HttpService, HttpServiceResponse } from '../shared'
import { ProductDetailsServerData, ProductPage, ProductList } from './product.types'

interface Attributes {
  [key: string]: string | number
}

export class ProductProvider {
  private get url(): string {
    return `${this.baseUrl}/product_view_api.php`
  }

  constructor(private http: HttpService, private baseUrl: string) {}

  public get<T>(page: ProductPage, attributes: Attributes = {}): Promise<HttpServiceResponse<T>> {
    const query = qs.stringify({
      page,
      ...attributes,
    })

    return this.http.post(`${this.url}?${query}`)
  }
}
